export default __webpack_public_path__ + "static/media/acneActive.c018ef25.svg";